/**
 * 409 `{ error: "EMPLOYEE_FORM_LOCKED" }` of my-onboarding patch, my-onboarding
 * link-file and onboarding/kiosk/submit: the employee already submitted the
 * step_2 form (in another tab, at the kiosk), so its data and linked
 * documents no longer change. Shown with the `employee_form_locked` text.
 */
export function isEmployeeFormLocked(error: any): boolean {
  return (
    error?.response?.status === 409 &&
    error?.response?.data?.error === "EMPLOYEE_FORM_LOCKED"
  );
}

/**
 * 400 `{ error: "FILE_NOT_A_FRESH_UPLOAD" }` of onboarding
 * upload-signed-document: the file is already signed or sent for signing, so
 * it is not the scan just uploaded. Shown with the `file_not_a_fresh_upload`
 * text.
 */
export function isFileNotAFreshUpload(error: any): boolean {
  return error?.response?.data?.error === "FILE_NOT_A_FRESH_UPLOAD";
}

/**
 * 400 `{ error: "DOCUMENT_ALREADY_SIGNED" }` of onboarding
 * upload-signed-document: the document was signed meanwhile, so the scan is
 * not needed. Shown with the `onboarding_document_already_signed` text.
 */
export function isDocumentAlreadySigned(error: any): boolean {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.error === "DOCUMENT_ALREADY_SIGNED"
  );
}

/**
 * 400 `{ error: "ALREADY_EMPLOYED_HERE", employeeName }` of onboarding create,
 * edit (email change) and reactivate: the person works in the company now,
 * so they are not hired again — HR registers their existing contract
 * instead. The backend names the person to HR only; a head gets the code
 * alone and is sent to HR. Returns the text key and its values, or null for
 * any other error.
 */
export function alreadyEmployedHereMessage(
  error: any
): { key: string; values?: { name: string } } | null {
  const data = error?.response?.data;
  if (data?.error !== "ALREADY_EMPLOYED_HERE") return null;
  if (!data.employeeName) return { key: "onboarding_employee_already_active" };
  return { key: "onboarding_already_employed_here", values: { name: data.employeeName } };
}
